import GameParameterInterface from '@/models/game/parameters/interface'

interface GachaLotteryParameter {
  prize: GachaGamePrize
  generalValue: string
}

interface GachaGamePrize {
  prizeImage: string,
}

export default class GachaParameter implements GameParameterInterface {
  constructor(private parameter: GachaLotteryParameter) { }

  createSetOption(): GachaLotteryParameter {
    return {
      prize: this.parameter.prize,
      generalValue: this.parameter.generalValue,
    }
  }

  get guideUrl(): string {
    return ''
  }
}
